import { OpenAPI } from 'services/openapi/core/OpenAPI';

export const applyAuthenticatedSession = () => {
  OpenAPI.HEADERS = {
    'Accept-Language': 'vi',
    'X-Client-Type': 'web',
  };
};
